import React from 'react'
import CandidateInformation from './CandidateInformation'
import PositionApplicationInformation from './PositionApplicationInformation'
import ResultCVInformation from './ResultCVInformation'

import { Cv } from '../../../types'

interface CVDetailViewProps {
    cv: any
    handleCvUrlClick: (
        url: string,
        isFile: boolean,
        cvName?: string
    ) => Promise<void>
    isGettingPresignedUrl: boolean
    matchedScreenResult: any
    matchedStatus: any
    mailTemplate: any
    setConfirmation: any
    handleSendMail: () => Promise<void>
    setShowDialogSendMailInterview: any
    showDialogSendMailInterview: {
        show: boolean
        data: Record<string, any> | null
    }
    refetch: any
    updateCVMutation: (values: Cv) => Promise<any>
}

const CVDetailView: React.FC<CVDetailViewProps> = ({
    cv,
    handleCvUrlClick,
    isGettingPresignedUrl,
    matchedScreenResult,
    matchedStatus,
    mailTemplate,
    setConfirmation,
    handleSendMail,
    setShowDialogSendMailInterview,
    showDialogSendMailInterview,
    refetch,
    updateCVMutation,
}) => {
    return (
        <div className="space-y-2">
            {/* Section 1 & 2: Thông tin ứng viên và vị trí */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <CandidateInformation
                    cv={cv}
                    updateCVMutation={updateCVMutation}
                />
                <PositionApplicationInformation
                    cv={cv}
                    updateCVMutation={updateCVMutation}
                />
            </div>

            {/* Section 3: Thông tin kết quả/CV */}
            <ResultCVInformation
                cv={cv}
                handleCvUrlClick={handleCvUrlClick}
                isGettingPresignedUrl={isGettingPresignedUrl}
                matchedScreenResult={matchedScreenResult}
                matchedStatus={matchedStatus}
                mailTemplate={mailTemplate}
                setConfirmation={setConfirmation}
                handleSendMail={handleSendMail}
                setShowDialogSendMailInterview={setShowDialogSendMailInterview}
                showDialogSendMailInterview={showDialogSendMailInterview}
                refetch={refetch}
                updateCVMutation={updateCVMutation}
            />
        </div>
    )
}

export default CVDetailView
